module.exports = __webpack_public_path__ + "sites/scf/favicons/favicons.webpackcruft";


//////////////////
// WEBPACK FOOTER
// ./client/src/site__scf001/favicons/html_code.html
// module id = /home/vsts/work/1/s/src/SCF/node_modules/file-loader/dist/cjs.js??ref--2-0!/home/vsts/work/1/s/src/SCF/node_modules/extract-loader/lib/extractLoader.js!/home/vsts/work/1/s/src/SCF/node_modules/html-loader/index.js??ref--2-2!/home/vsts/work/1/s/src/SCF/client/src/site__scf001/favicons/html_code.html
// module chunks = site__scf001